<template>
  <div class="z-50 fixed w-full h-full top-0 left-0 flex items-center">
    <div
      class="absolute w-full h-full bg-gray-900 opacity-50"
      @click.self="close"
    ></div>
    <div
      style="height: 37rem;"
      class="bg-white w-11/12 mt-5 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyModalBase",
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped></style>
